import NavigationBottom from 'component/navigation/navigation_bottom_home';
import NavigationBottomStylist from 'component/navigation/navigation_bottom_stylist';
import UserType from 'constants/user';
import NavigationBottomAnonymous from 'component/navigation/navigation_bottom_anonymous';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { PATH } from './constant';

export const BottomNavigationProvider = () => {
    const user = useSelector((state: RootState) => state.userDetail.me);
    const isShow = useSelector((state: RootState) => state.global.showBottomNavigationBar);
    const additionWidgetPreventRoutes = [
        PATH.LOGIN,
        PATH.SIGNUP_CUSTOMER,
        PATH.INTRO,
        PATH.STYLE_REQUEST_QUIZ,
        PATH.QUIZ_MANAGER,
    ];
    if (additionWidgetPreventRoutes.some((route) => window.location.pathname.includes(route))) return null;
    if (!isShow) return null;
    return (
        <div style={{ minHeight: 56, maxHeight: 56 }}>
            {user && user.userType === UserType.Customer ? (
                <NavigationBottom />
            ) : user && user.userType === UserType.Stylist ? (
                <NavigationBottomStylist />
            ) : (
                <NavigationBottomAnonymous />
            )}
        </div>
    );
};

export const BottomNavigationPlaceHolder = () => {
    return <div style={{ flex: 1, maxHeight: 56 }}></div>;
};
